import { type UseQueryOptions, useQuery } from '@tanstack/react-query'
import {
	type HttpGetServiceGalleryImagesProPhotosOptions,
	type HttpGetServiceGalleryImagesProPhotosResponse,
	httpGetServiceGalleryImagesProPhotos
} from '@/features/service-vetting/http/services-vetting.http.ts'
import { QUERY_KEYS } from '@/query-client'

export const useGetGalleryImagesProPhotos = (
	urlParams: HttpGetServiceGalleryImagesProPhotosOptions['urlParams'],
	options?: Omit<
		UseQueryOptions<HttpGetServiceGalleryImagesProPhotosResponse>,
		'queryFn' & 'queryKey'
	>
) =>
	useQuery({
		...options,
		queryKey: [
			QUERY_KEYS.SERVICE_GALLERY_IMAGES_PRO_PHOTOS,
			urlParams.serviceId
		],
		queryFn: () =>
			httpGetServiceGalleryImagesProPhotos({
				urlParams,
				params: { responseType: 'extended' }
			})
	})
